import { useQuery } from '@tanstack/react-query';
import { getLocationAlerts, queryKeys } from '@vgrubs/components';

/**
 * What a location is missing on file and its open system problems. The
 * backend works both out on every call, so this only needs refetching after
 * something changed: the screen invalidates it when Bank Details closes, and
 * a problem being resolved anywhere invalidates every location's.
 */
export const useLocationAlerts = ({
  locationId,
  enabled,
}: {
  locationId: number | string;
  /** Admin and support only: anyone else gets a 403. */
  enabled: boolean;
}) => {
  const query = useQuery({
    queryKey: queryKeys.locationInsights.alerts(locationId),
    queryFn: async () => {
      const { data } = await getLocationAlerts(locationId);
      return data.data;
    },
    enabled,
  });

  return {
    alerts: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
